export default function JobType(props) {
  return (
    <div className="flex-col justify-start items-start gap-2 inline-flex">
      <p className="text-indigo-700 text-sm font-medium">
        {props.jobType}
      </p>{/* 
      <p className="text-black text-opacity-90 text-xs font-normal">
        {`${props.experience} years experience`}
      </p> */}
    </div>
  );
}